import { API_UPDATE_CLOSED_SHOP } from '../../constants';
import store from '../../utils/store';
import { sendPostRequest } from '../../utils/apiService';


export const onChangeClosedShop = async newState => {
  const { user = {} } = store.getState();
  const { initializedApp, shopId } = user;
  const idToken = await initializedApp.auth().currentUser.getIdToken(true);
  await sendPostRequest(
    API_UPDATE_CLOSED_SHOP,
    {
      shopId,
      closed: newState
        ? false
        : 'Notre magasin est temporairement fermé, merci de réessayer ultérieurement'
    },
    { Authorization: `Bearer ${idToken}` }
  );

  return true;
};
